export const BREAKPOINT_SM_MOBILE = 769

export const BREAKPOINT_XS_MOBILE = 480
